import { Icon, IconProps } from '@chakra-ui/react';

export default function CodeIcon({ ...props }: IconProps) {
  return (
    <Icon viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M28 35L44.5618 51.5618L28 68.1236"
        stroke="#7CCEE0"
        strokeWidth="3.02222"
        strokeLinejoin="round"
      />
      <path
        d="M47.2666 72.2488H79.9066"
        stroke="#7CCEE0"
        strokeWidth="3.02222"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
